import React from "react";
import {
    Navigate
} from "react-router-dom";
import {getAccessToken, getSchoolId} from "./authority";
export function checkPermission(name) {
    let isHave = getSchoolId >= 0
    const permissions = JSON.parse(localStorage.getItem("sas_school_per"));
    if (permissions === null || permissions === undefined)
        return false
    return permissions.includes(name)
}

export function checkViewPermission(name) {
    const permissions = JSON.parse(localStorage.getItem("sas_school_per"));
    if (permissions === null || permissions === undefined)
        return false
    return permissions.includes(name)
}

export function RequireAuth({ children, redirectTo }) {
    let token = getAccessToken();
    return !!token ? children : <Navigate to={redirectTo} replace />;
}


export function RedirectAuth({ children, redirectTo }) {
    let token = getAccessToken();
    return !!token ? <Navigate to={redirectTo} replace />: children;
}
export function changeAlias(alias) {
    if(alias) {
        let str = alias;
        str = str.toLowerCase();
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/đ/g, "d");
        str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
        str = str.replace(/ + /g, " ");
        str = str.trim();
        return str;
    }
    return alias;
}
